import { render } from "./Mentions.vue?vue&type=template&id=2f3b3c5d&scoped=true"
const script = {}

import "./Mentions.vue?vue&type=style&index=0&id=2f3b3c5d&scoped=true&lang=css"

import exportComponent from "/var/www/ca-quiz.staging.mindoza.net/releases/20240705152708/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3b3c5d"]])

export default __exports__